import {ButtonGroup, HeaderTitle} from '@/components/atoms'
import {useProductCombo} from '@/context/ProductCombo/ProductComboContext'
import {useComboActions} from '@/hooks/productCombo/useComboActions'
import {useGetComboPromotion} from '@/hooks/productCombo/useGetComboPromotion'
import DeleteComboProductModal from '@/pages/ProductCombo/ComboDetail/DeleteComboModal'
import {convertISOToLocal} from '@/utility/dateHelper'
import {Header} from '@/utils/constants/header'
import {Font} from 'pepsico-ds'
import {useState} from 'react'

export const PublishedComboHeader = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const {
    productCombo: {name, updatedDateTime, productId, isDraft},
  } = useProductCombo()
  const {duplicateProductCombo} = useComboActions()
  const publishedDateTime = convertISOToLocal(updatedDateTime)?.replace(', ', ' at ') || '-'
  const promotions = useGetComboPromotion(productId)
  const promotionsCount = promotions?.length

  const groupedButtons = [
    {
      icon: 'copy',
      label: 'Duplicate',
      onClick: () => duplicateProductCombo(),
    },
    {
      icon: 'delete',
      label: 'Delete',
      onClick: () => setModalOpen(true),
    },
  ]

  return (
    <>
      <HeaderTitle title={name} headingLevel={Header.PageHeader} className="$font-heading-h3-bold" />
      <div className="flex items-center justify-between">
        <Font size="small" variant="medium">
          {!isDraft ? `Published on ${publishedDateTime}` : ''}
        </Font>
        <ButtonGroup uiSchema={{items: groupedButtons}} />

        <DeleteComboProductModal
          show={modalOpen}
          onClose={() => setModalOpen(false)}
          promotionNumber={promotionsCount}
          comboId={productId}
        />
      </div>
    </>
  )
}
